import {useEffect} from 'react';

// Calls `callback` when the user comes back to the tab or to the browser window,
// e.g. after asking the assistant to generate documents in another app.
export default function useOnPageReturn(callback) {
	useEffect(() => {
		const onReturn = () => {
			if (!document.hidden) callback();
		};
		document.addEventListener('visibilitychange', onReturn);
		window.addEventListener('focus', onReturn);
		return () => {
			document.removeEventListener('visibilitychange', onReturn);
			window.removeEventListener('focus', onReturn);
		};
	}, [callback]);
}
